import React from 'react'
import { Typography } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import { branding } from '../../constants/branding.constants'
import { SubHeader } from './SubHeader'
import { userService } from '../../services/user.service'

const useStyles = makeStyles(theme => ({
    root: {
        height: 120,
        padding: '0 30px',
        background: theme.palette.header.main,
        color: theme.palette.getContrastText(theme.palette.header.main),
    },
    logo: {
        maxWidth: 400,
        maxHeight: 125,
    },
    brandWelcomeText: {
        fontSize: '1rem',
        marginTop: '4px',
    },
}))

export function Header() {
    const classes = useStyles()
    const managedService = userService.getManagedService()

    return (
        <>
            <Box
                display='flex'
                className={classes.root}
                justifyContent='center'
                id='header'>
                <Box
                    p={1}
                    flexShrink={0}
                    display='flex'
                    alignItems='center'
                    justifyContent='center'>
                    <Link component={RouterLink}>
                        <img
                            src={branding.logoUrl}
                            className={classes.logo}
                            alt={'logo'}
                        />
                    </Link>
                </Box>
                <Box
                    p={1}
                    flexShrink={0}
                    flexGrow={1}
                    display='flex'
                    alignItems='top'
                    justifyContent='flex-end'
                    className={classes.sectionTablet}>
                    <Typography className={classes.brandWelcomeText}>
                        {managedService == null ? (
                            <>
                                Welcome to
                                <strong> Service Management</strong>
                            </>
                        ) : (
                            <>
                                Currently Managing
                                <strong> {managedService?.value}</strong>
                            </>
                        )}
                    </Typography>
                </Box>
            </Box>
            <SubHeader />
        </>
    )
}
